import { TripSanitarityMode } from 'app/constants/configuration/tripSanitarityMode'

export const getTripSanitarityModeName = (
  tripSanitarityMode: TripSanitarityMode,
  translate: (string) => string,
): string => {
  const text: string = TripSanitarityMode[tripSanitarityMode]
  return translate(`tripSanitarityMode.${text}`)
}
